/** NOS-127: Supabase Edge Function URL for org podcast RSS. */
export function getPodcastFeedUrl(orgSlug: string): string {
  const base = import.meta.env.VITE_SUPABASE_URL?.replace(/\/$/, "") ?? ""
  if (!base || !orgSlug) return ""
  return `${base}/functions/v1/media-podcast-feed?slug=${encodeURIComponent(orgSlug)}`
}
